import { useSelector } from 'react-redux';
import Huevos from '../../assets/Products/huevos.png';
import Pollo from '../../assets/Products/Pollo_campesino.jpg'
import Lechuga from '../../assets/Products/Lechuga.jpg'
import Gallinaza from '../../assets/Products/Gallinaza.jpg'
import {BsWhatsapp} from "react-icons/bs";
import style from './Products.module.css';


const Products = () => {
  
  const leng = useSelector((state)=>state.lenguage);
  let main;
  let title;
  let price;
  let request;
    
 let currentCards = [];
  

  const images = [Huevos, Pollo, Lechuga, Gallinaza];
    if(leng) {
      main = "Nuestros Productos"
    title = ["PANAL HUEVO CRIOLLO", "POLLO CAMPESINO", "LECHUGA", "GALLINAZA"];
    price = ["$30000","$9000 Libra","$8000", "$8000 Bulto"];
    request = "Haz tu pedido"
  }
  else{
    main = "Our Products"
    title = ["PEASANT EGG COMB", "PASTURE-RAISED CHICKEN", "LETTUCE", "POULTRY MANURE"];
    price = ["$30000","$9000 Pound","$8000", "$8000 Bag"];
    request = "Place your order"
  } 
  
  
  for (let i=0; i< 4; i++) {
      currentCards.push({id:i, image:images[i], title:title[i], price:price[i]})
  }
   
return (
    <div className={style.actividad}>
      <p className={style.title}>{main}</p>
      <div className={style.tarjetas}>
        {currentCards.map((p) => (
          <div key={p.id}>     
              <div className={style.card}>
                <img className={style.imagen}src={p.image} alt="" />
                <div /*className={style.descripcion}*/>
                    <h2 className={style.name}>{p.title}</h2>
                     <h2 className={style.name}>{p.price}</h2>
                </div>
              </div>
            
            
          </div>
        ))}
      </div>
      <div className={style.pedido}>
        <p>{request} 👉 </p>
        <a className={style.whatsapp} href="https://wa.me/573116233078?text=Hola,%20estoy%20interesado%20en%20un%20producto
                                          %20de%20la%20granja">
          < BsWhatsapp  size={50}/>    
        </a>
      </div>
      
     
    
    </div>
  );
};
export default Products;